export default __webpack_public_path__ + "static/media/homepage1.937fdacc.png";